module.exports = __webpack_public_path__ + "static/media/tinjul-ico.e998024e.png";